import { Badge } from "@/components/ui/badge";

const FAQ_ITEMS = [
  { q: "Combien de temps pour réparer un écran d'iPhone à Niort ?", a: "Chez Mediastore Niort, le remplacement d'un écran iPhone est généralement effectué en 30 à 60 minutes sur place. Vous pouvez attendre en boutique ou repasser dans la journée." },
  { q: "Quels modèles d'iPhone réparez-vous ?", a: "Tous les modèles iPhone, du iPhone 6 au dernier iPhone 15 Pro Max : écran, batterie, connecteur de charge, caméra, haut-parleur, désoxydation. Pièces premium garanties 6 mois." },
  { q: "Travaillez-vous sur les Samsung et Android ?", a: "Oui. Mediastore Niort répare Samsung Galaxy (S22, S23, S24, A54, A34, Note, Tab S), Huawei (P60, P50, Mate, Nova), Xiaomi (14, 13, Redmi Note, Poco), OnePlus, Google Pixel, Honor, Oppo, Vivo." },
  { q: "Mon iPhone est tombé dans l'eau, que faire ?", a: "Intervention d'urgence possible. Apportez-le immédiatement éteint, sans le rallumer. Notre service de désoxydation démarre à 69 €. Plus vous attendez, plus l'oxydation progresse." },
  { q: "Réparez-vous aussi les iPad et tablettes ?", a: "Oui. Tous modèles iPad (Pro 12.9\", Pro 11\", Air, Mini, iPad 10/9/8) et tablettes Samsung Galaxy Tab. Écran et batterie disponibles dès 155 €." },
  { q: "Les pièces sont-elles d'origine ?", a: "Nous utilisons soit des pièces Apple d'origine, soit des pièces compatibles premium de très haute qualité, selon votre budget. Devis transparent avec choix avant intervention." },
  { q: "Avez-vous une garantie sur la réparation iPhone ?", a: "Toutes nos réparations iPhone, iPad et smartphones bénéficient d'une garantie 6 mois sur les pièces et la main d'œuvre." },
  { q: "Puis-je avoir un devis sans me déplacer ?", a: "Oui. Utilisez notre formulaire en ligne ou appelez le 05 49 05 74 90. Devis personnalisé sous 24 h, sans engagement." },
];

export const PhoneFAQSection = () => (
  <section className="section-padding bg-slate-50" data-testid="phone-faq-section">
    <div className="container-custom max-w-4xl">
      <div className="text-center mb-12">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">FAQ</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Questions fréquentes - Réparation Téléphone
        </h2>
        <p className="text-lg text-slate-600">
          iPhone, iPad, Samsung, Huawei, Xiaomi : tout savoir avant de venir
        </p>
      </div>

      <ol className="space-y-4 list-none p-0">
        {FAQ_ITEMS.map((item, i) => (
          <li key={item.q} className="bg-white rounded-xl p-6 hover:bg-red-50 transition-colors shadow-sm" data-testid={`phone-faq-${i}`}>
            <h3 className="font-bold text-lg text-slate-900 mb-2 flex gap-3">
              <span className="text-red-600 flex-shrink-0">{i + 1}.</span>
              <span>{item.q}</span>
            </h3>
            <p className="text-slate-700 leading-relaxed pl-7">{item.a}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
